import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { StickyNavModule } from 'ng2-sticky-nav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TabsModule } from 'ngx-tabset';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { NgxSmartModalModule } from 'ngx-smart-modal';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLandingComponent } from './components/pages/app-landing/app-landing.component';

import { NavbarComponent } from './components/common/navbar/navbar.component';

import { FooterComponent } from './components/common/footer/footer.component';
import { NewsletterComponent } from './components/common/newsletter/newsletter.component';
// app-landing
import { AppBannerComponent } from './components/pages/app-landing/app-banner/app-banner.component';
import { AppWhyChooseComponent } from './components/pages/app-landing/app-why-choose/app-why-choose.component';
import { AppFeaturesComponent } from './components/pages/app-landing/app-features/app-features.component';
import { AppScreenshotsComponent } from './components/pages/app-landing/app-screenshots/app-screenshots.component';
import { AppHowToUseComponent } from './components/pages/app-landing/app-how-to-use/app-how-to-use.component';
import { AppPricingComponent } from './components/pages/app-landing/app-pricing/app-pricing.component';
import { AppTestimonialsComponent } from './components/pages/app-landing/app-testimonials/app-testimonials.component';

import { AppFaqComponent } from './components/pages/app-landing/app-faq/app-faq.component';
import { HttpClientModule } from '@angular/common/http';
import { AppLoaderComponent } from './components/pages/app-landing/app-loader/app-loader.component';

@NgModule({
    declarations: [
        AppComponent,

        AppLandingComponent,
        NavbarComponent,

        FooterComponent,
        NewsletterComponent,

        AppBannerComponent,
        AppWhyChooseComponent,
        AppFeaturesComponent,
        AppScreenshotsComponent,
        AppHowToUseComponent,
        AppPricingComponent,
        AppTestimonialsComponent,



        AppFaqComponent,
              AppLoaderComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        StickyNavModule,
        BrowserAnimationsModule,
        CarouselModule,
        NgxSmartModalModule.forRoot(),
        TabsModule,
        NgxScrollTopModule,
        HttpClientModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }